import React from 'react';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';
import styles from './AnalyticsKpiCard.module.scss';
import { MetricResult } from '../../../../types/adminAnalytics.ts';
import { formatDeltaPercent, formatDeltaValue } from '../../../../utils/adminAnalyticsHelpers.ts';

interface AnalyticsKpiCardProps {
  metric: MetricResult;
  onClick?: () => void;
}

const AnalyticsKpiCard: React.FC<AnalyticsKpiCardProps> = ({ metric, onClick }) => {
  const dimensionEntries = Object.entries(metric.dimensions ?? {}).filter(
    ([, value]) => value
  );

  const TrendIcon =
    metric.trend === 'up' ? TrendingUp : metric.trend === 'down' ? TrendingDown : Minus;

  const trendClass =
    metric.trend === 'up'
      ? styles.trendUp
      : metric.trend === 'down'
        ? styles.trendDown
        : styles.trendFlat;

  return (
    <div
      className={`${styles.card} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className={styles.header}>
        <span className={styles.label}>{metric.label}</span>
        <span className={`${styles.trendBadge} ${trendClass}`}>
          <TrendIcon size={14} />
          <span>{formatDeltaPercent(metric.deltaPercent)}</span>
        </span>
      </div>
      <span className={styles.value}>{metric.current.toLocaleString('es-AR')}</span>
      <span className={styles.compare}>
        vs período anterior: {metric.previous.toLocaleString('es-AR')} (
        {formatDeltaValue(metric.delta)})
      </span>
      {onClick && <span className={styles.viewDetail}>Ver detalle</span>}
      {dimensionEntries.length > 0 && (
        <div className={styles.chips}>
          {dimensionEntries.map(([key, value]) => (
            <span key={`${key}-${value}`} className={styles.chip}>
              {key}: {value}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalyticsKpiCard;
